import Frames from "@frog/source/engine/animating/Frames.js"

export default {
    "frames": Frames.run({
        "tweentime": 80,
        "images": [
            require("./spawneranim-monogreen-0000.png"),
            require("./spawneranim-monogreen-0001.png"),
            require("./spawneranim-monogreen-0002.png"),
            require("./spawneranim-monogreen-0003.png"),
            require("./spawneranim-monogreen-0004.png"),
            require("./spawneranim-monogreen-0005.png"),
            require("./spawneranim-monogreen-0006.png"),
            require("./spawneranim-monogreen-0007.png"),
            require("./spawneranim-monogreen-0008.png"),
            require("./spawneranim-monogreen-0009.png"),
            require("./spawneranim-monogreen-0010.png"),
            require("./spawneranim-monogreen-0011.png"),
            require("./spawneranim-monogreen-0012.png"),
            require("./spawneranim-monogreen-0013.png"),
            require("./spawneranim-monogreen-0014.png"),
            require("./spawneranim-monogreen-0015.png"),
        ]
    })
}
